import { useQueryClient } from '@tanstack/react-query';

import { useQuery } from '@hooks/reactQuery';

import { getActiveOranAlarms } from '@api/alarmHistory';

import { extractQueryParams } from '@utils/common';

import { IActiveAlarmOran } from '@interfaces/alarms/alarm';
import { IAlarmByVendor } from '@interfaces/alarms/dto/alarmsDTO';

import { HISTORY_ALARMS_ORAN } from '@constants/queryKeys';

interface IUseQueryHistoryAlarmsListOranReturn {
	isLoading: boolean;
	data: IActiveAlarmOran[];
	countOfRecords: number;
	invalidateQuery: () => void;
}

export const useQueryHistoryAlarmsListOran = (
	params: IAlarmByVendor,
): IUseQueryHistoryAlarmsListOranReturn => {
	const queryClient = useQueryClient();

	const { isEnabled: isEnabledTab, ...restParams } = params;

	const {
		data,
		isInitialLoading: isLoadingAlarmsOran,
	} = useQuery({
		queryKey: [HISTORY_ALARMS_ORAN, restParams],
		queryFn: extractQueryParams(getActiveOranAlarms),
		enabled: [isEnabledTab],
		refetchOnWindowFocus: false,
	});

	const invalidateQuery = () => {
		return [queryClient.invalidateQueries([HISTORY_ALARMS_ORAN])];
	};

	return {
		isLoading: isLoadingAlarmsOran,
		data: data?.items || [],
		countOfRecords: data?.count || 0,
		invalidateQuery,
	};
};
